export default __webpack_public_path__ + "static/media/digesta.5cec0722.svg";